export default __webpack_public_path__ + "static/media/palaute-white.47d2af63.svg";